import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"minus\">\n  <path fill=\"#352C0B\" d=\"M85 42v5H7v-5h78Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol